<template>
  <div class="personalInfo-wrap" id="personalInfo-wrap-id">
    <h2>Personal Information</h2>
    <p>Enter and Update all your Personal Information here.</p>
    <div class="personalInfo-form">
      <form action=""  @keydown.enter.prevent="handleEnterKey">

        <div class="form-group row">
          <div class="col-xxl-4 col-lg-6 col-md-6 mb-3">
            <input-text
              :rules="{ required: true, digits: 10 }"
              labelFor="cell_phone"
              labelName="Cell Phone"
              :vmodel.sync="personalInfo.cell_phone"
              placeholder="no dashes eg: 123456789)"
              formGroupClass=""
              inputType="text"
              maxlength="10"
              inputmode="numeric"
             pattern="\d*"
              @input.native="enforceDigitLimit"
              @keypress.native="onlyAllowDigits"
            />
            <!-- <div class=" row justify-content-between validation-row mt-2"> -->
              <!-- <span
                class="skip-email-verify col-md-7 col-sm-6 d-flex align-items-center"
              >
                <input class="me-1" type="checkbox">
                <label class="m-0">Skip verification</label>
            </span> -->
              <!-- <a 
                href="#" 
                class="validate-via-otp-link validate-btn col-md-5 col-sm-6"
                @click.prevent="initiateOtpValidation('phone', personalInfo.cell_phone)" 
              >
                Validate via OTP
              </a> -->
              <!-- <span >Validating...</span> -->
            <!-- </div> -->
            <span v-if="showOtpSectionPhone" class="validate-btn col-md-5 col-sm-6 d-flex rep-otp-validation">
              <a href="#" class="validate-via-otp-link mt-2" @click.prevent="openOtpModal('phone')" >
                  TO CONTINUE, PLEASE CLICK HERE TO VERIFY YOUR PHONE.
              </a>
            </span>
                        
            <!-- to show the error message dynamically under the fields -->
            <div v-if="phoneMsg" class="contacts-message-container form-group">
              <div :class="['validate-message mt-2',phoneValidationMessage.type]">
                <div :class="['message-indicator', `${phoneValidationMessage.type}-indicator`]"></div>
                <span class="message-text">
                  <strong :class="`${phoneValidationMessage.type}-text`">{{ phoneValidationMessage.title }}</strong> - 
                  {{ phoneValidationMessage.message }}
                </span>
              </div>
            </div>

            <div v-if="errors.cell_phone" class="error-message">
              <small>{{ errors.cell_phone }}</small>
            </div>
          </div>
          
          <div class="col-xxl-4 col-lg-6 col-md-6 mb-3">
          

               <input-text
               :rules="{ required: true, email: true }"


                labelFor="Email Address"
                labelName="Email Address"
                placeholder="Enter Email Address"
                :vmodel.sync="personalInfo.email"
                formGroupClass=""
              />

            <!-- <div class=" row justify-content-between validation-row mt-2">
              <span
                class="skip-email-verify col-md-7 col-sm-6 d-flex align-items-center"
              >
                <input class="me-1" type="checkbox">
                <label class="m-0">Skip verification</label>
            </span>
              <a 
                href="#" 
                class="validate-via-otp-link validate-btn col-md-5 col-sm-6"
                @click.prevent="initiateOtpValidation('email', personalInfo.email)"
              >
                Validate via OTP
              </a>
       
            </div> -->


            <span v-if="showOtpSectionEmail" class="validate-btn col-md-5 col-sm-6 d-flex rep-otp-validation">
              <a href="#" class="validate-via-otp-link mt-2" @click.prevent="openOtpModal('email')" >
                  TO CONTINUE, PLEASE CLICK HERE TO VERIFY YOUR EMAIL.
              </a>
            </span>


                        
                <!-- to show the error message dynamically under the fields -->
            <div v-if="emailMsg" class="contacts-message-container form-group">
              <div :class="['validate-message mt-2',emailValidationMessage.type]">
                <div :class="['message-indicator', `${emailValidationMessage.type}-indicator`]"></div>
                <span class="message-text">
                  <strong :class="`${emailValidationMessage.type}-text`">{{ emailValidationMessage.title }}</strong> - 
                  {{ emailValidationMessage.message }}
                </span>
              </div>
            </div>

          </div>
        </div>

        <div class="form-group row">
          <div class="col-xxl-4 col-lg-4 col-md-6 mb-3">
            <label for=""
              >Agent Code <span class="required-indc">*</span></label
            >
            <input
              type="text"
              placeholder="Enter Agent Code"
              name="agent_code"
              class="accountInfo-field"
              v-model="personalInfo.agent_code"
              disabled
            />
            <div v-if="errors.agent_code" class="error-message">
              <small>{{ errors.agent_code }}</small>
            </div>
          </div>
          <div class="col-xxl-4 col-lg-4 col-md-6 mb-3">
            <label for="">DOB <span class="required-indc">*</span></label>
            <date-picker
              input-class="accountInfo-field"
              placeholder="MM/DD/YYYY"
              value-type="format"
              format="MM/DD/YYYY"
              v-model="personalInfo.dob"
            ></date-picker>
            <div v-if="errors.dob && !personalInfo.dob" class="error-message">
              <small>{{ errors.dob }}</small>
            </div>
          </div>
          <div class="col-xxl-4 col-lg-4 col-md-6 mb-3">
            <label for="">SSN <span class="required-indc">*</span></label>
            <input
              type="text"
              placeholder="Enter SSN Number"
              name="ssn"
              class="accountInfo-field"
              v-model="personalInfo.ssn"
              @input="handleInputChange"
            />
            <div v-if="errors.ssn" class="error-message">
              <small>{{ errors.ssn }}</small>
            </div>
          </div>
        
          <div class="col-xxl-4 col-lg-4 col-md-6 mb-3">
            <label for=""
              >First Name <span class="required-indc">*</span></label
            >
            <input
              type="text"
              placeholder="Enter First Name"
              name="first_name"
              class="accountInfo-field"
              v-model="personalInfo.first_name"
              @input="handleInputChange"
            />
            <div v-if="errors.first_name" class="error-message">
              <small>{{ errors.first_name }}</small>
            </div>
          </div>
          <div class="col-xxl-4 col-lg-4 col-md-6 mb-3">
            <label for="">Middle Name </label>
            <input
              type="text"
              placeholder="Enter Middle Name"
              name="middle_name"
              class="accountInfo-field"
              v-model="personalInfo.middle_name"
              @input="handleInputChange"
            />
            <div v-if="errors.middle_name" class="error-message">
              <small>{{ errors.middle_name }}</small>
            </div>
          </div>
          <div class="col-xxl-4 col-lg-4 col-md-6 mb-3">
            <label for="">Last Name <span class="required-indc">*</span></label>
            <input
              type="text"
              placeholder="Enter Last Name"
              name="last_name"
              class="accountInfo-field"
              v-model="personalInfo.last_name"
              @input="handleInputChange"
            />
            <div v-if="errors.last_name" class="error-message">
              <small>{{ errors.last_name }}</small>
            </div>
          </div>
        </div>

        <div class="form-group row">
          <div class="col-xxl-4 col-lg-4 col-md-6 mb-3">
            <label for="">Telephone </label>
            <input
              type="text"
              placeholder="eg: 1235688978 / no dashes"
              name="telephone"
              class="accountInfo-field"
              v-model="personalInfo.telephone"
              @input="handleInputChange"
            />
            <div v-if="errors.telephone" class="error-message">
              <small>{{ errors.telephone }}</small>
            </div>
          </div>
          <div class="col-xxl-4 col-lg-4 col-md-6 mb-3">
            <label for="">Fax</label>
            <input
              type="text"
              placeholder="eg: 1235688978 / no dashes"
              name="fax"
              class="accountInfo-field"
              v-model="personalInfo.fax"
            />
          </div>
          <div class="col-xxl-4 col-lg-4 col-md-6 mb-3">
            <label for="">800 Number </label>
            <input
              type="text"
              placeholder="eg: 800688978 / no dashes"
              name="num_800"
              class="accountInfo-field"
              v-model="personalInfo.num_800"
            />
          </div>
        </div>

        <div class="form-group row image-row">
          <input-image
            @deleteImage="deleteImage('personal', ()=>deleteImageRef('personal'))"
            :rules="{ required: false }"
            ref="image"
            labelFor="image"
            labelName="Personal Photo Image"
            :vmodel.sync="agentImg"
            formGroupClass="col-xxl-4 col-xl-4 col-lg-4 col-md-6 mb-4 image-row"
            :imgSrc="imgSrc"
            imgClass="downline-upload-img ai-downline-img-preview"
            :imageSource="personalImageSource"
          />

          <input-image
            @deleteImage="deleteImage('business', ()=>deleteImageRef('business'))"
            :rules="{ required: false }"
            ref="image"
            labelFor="image"
            labelName="Business Logo Image"
            :vmodel.sync="businessLogo"
            formGroupClass="col-xxl-4 col-xl-4 col-lg-4 col-md-6 mb-4 image-row"
            :imgSrc="businessImage"
            imgClass="downline-upload-img"
            :imageSource="businessImageSource"
          />
        </div>
        <div class="form-group row ai-location-wrapper">
          <label for=""
            >Address Information
            <i class="fas fa-plus-circle" v-b-modal.addAddress></i
          ></label>
          <div
            v-for="address in addressInfo"
            :key="address.id"
            class="col-md-6 col-sm-12 mb-3"
          >
            <div v-if="address.is_active" class="location-div primary-location">
              <p>
                {{ address.address1 }}, {{ address.address2 }}
                <i
                  :class="
                    address.usps_verified
                      ? 'fas fa-check-circle'
                      : 'fas fa-exclamation-triangle'
                  "
                  v-b-tooltip.hover
                  :title="
                    address.usps_verified
                      ? 'Validated with USPS'
                      : 'Not validated with USPS'
                  "
                ></i>
                <br />{{ address.city }}, {{ address.state }}, {{ address.zip }}
              </p>
              <button class="primaryAdrs-btn">Primary</button>
            </div>
            <div v-else class="location-div set-as-primary">
              <p>
                {{ address.address1 }}, {{ address.address2 }}
                <i
                  :class="
                    address.usps_verified
                      ? 'fas fa-check-circle'
                      : 'fas fa-exclamation-triangle'
                  "
                  v-b-tooltip.hover
                  :title="
                    address.usps_verified
                      ? 'Validated with USPS'
                      : 'Not validated with USPS'
                  "
                ></i>
                <br />{{ address.city }}, {{ address.state }}, {{ address.zip }}
              </p>
              <button
                type="button"
                class="primaryAdrs-btn"
                @click="updateAsPrimary(address.id)"
              >
                Set as Primary
              </button>
              <a
                class="ai-delete-a"
                type="button"
                v-b-tooltip.hover
                title="Delete"
                @click="deleteAddress(address.id)"
                ><i class="fas fa-trash"></i
              ></a>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-xxl-3 col-xl-3 col-lg-3 col-md-6">
            <button
              type="button"
              class="univ-btn"
              v-on:click="updatePersonalInfo()"
            >
              {{ this.processing ? "Processing..." : "Update" }}
            </button>
          </div>
        </div>
      </form>
      <AccountInfoOTP 
    v-model="showOtpModal"
    :identifier="contactInfo"
    :identifierTypeText="otpType"
    :field="field"
    @save="handleVerificationResult"
    @close="closeOtpModal"
      />
    </div>
  </div>
</template>
<script>
import Api from "@/resource/Api";
import Helper from "@/resource/Helper";
import dummyImage from "@/assets/images/upload-dummy.png";
import AccountInfoOTP from '../Nuera/AccountInfoOTP.vue';

const emptyPersonalInfo = {
  agent_code: "",
  name: "",
  dob: "",
  ssn: "",
  address_line_1: "",
  address_line_2: "",
  city: "",
  state: "",
  zip: "",
  telephone: "",
  fax: "",
  cell_phone: "",
  num_800: "",
  email: "",
  default_payment_type: "",

};

export default {
  name: "PersonalInfoNuera",
  props: {
    tabIndex: {
      required: true,
    },
  },
  components: {
    AccountInfoOTP
  },
  data() {
    return {
      type: "personal",
      version: process.env.VUE_APP_API_VERSION,
      personalInfo: { ...emptyPersonalInfo },
      agentImage: {
        image: "",
      },
      addressInfo: [],
      imageUpdate: false,
      errors: [],
      processing: false,
      dateFormat: "DD/MM/YYYY",
      dummyImage,
      imgSrc: "",
      updateInfoInStorage: false,
      agentImg: null,
      businessLogo: null,
      businessImage: null,
      personalImageSource: "",
      businessImageSource: "",

      showOtpModal: false,
      showOtpSectionEmail: false,
      showOtpSectionPhone: false,
      phoneValidationMessage: null,
      emailValidationMessage: null,
      phoneMsg: false,
      emailMsg: false,
      validationStatus: null,
      emailVerified: false,
      phoneVerified: false,
      contactInfo: null,
      otpType: null,
      field: null,
      

     
    };
  },
  created() {
    this.getAgentPersonalInfo();
    this.getPersonalAddressList();
  },
  computed: {
    addressStatus() {
      return this.$store.getters.getAddressListStatus;
    },
  },
  watch: {
    addressStatus: {
      handler: function (newValue) {
        if (newValue) {
          this.getPersonalAddressList();
        }
      },
    },
     'personalInfo.cell_phone'(val) {
    // Only allow digits and limit to 10
    const cleaned = val.replace(/\D/g, '').slice(0, 10);
    if (val !== cleaned) {
      this.personalInfo.cell_phone = cleaned;
    }
  }},
  methods: 
{


      handleEnterKey() {
      // Different method for Enter key
      console.log('Enter key pressed');
      this.updatePersonalInfo(); // Your custom method
    },
  enforceDigitLimit(event) {
    const raw = event.target.value;
    const digitsOnly = raw.replace(/\D/g, '').slice(0, 10);
    this.personalInfo.cell_phone = digitsOnly;

    // Also fix the displayed value (if your component doesn't sync automatically)
    event.target.value = digitsOnly;
  },
   onlyAllowDigits(event) {
    const key = event.key;
    if (!/^\d$/.test(key)) {
      event.preventDefault();
    }
  },
  resetValidationState() {
      this.validationStatus = null;
      this.emailValidationMessage = null;
      this.phoneValidationMessage = null;
      this.emailMsg = false;
      this.phoneMsg = false;
      this.showOtpSectionEmail = false;
      this.showOtpSectionPhone = false;
      // this.skipEmailVerification = false;
      // this.skipPhoneVerification = false;
      this.emailVerified = false;
      this.phoneVerified = false;
 



   
    },
handleVerificationResult(result) {
  if (result.verified) {
    // Handle successful verification
    if (result.type === 'phone' && result.field === 'phone') {
      this.phonemsg = true;

      this.phoneValidationMessage = {
        type: 'success',
        title: 'Success',
        message: 'Your phone has been verified!'
      };
      this.showOtpSectionPhone = false;
    } else if (result.type === 'email' && result.field === 'email') {
      this.emailMsg = true;
      this.emailVerified = true;
      this.emailValidationMessage = {
        type: 'success',
        title: 'Success',
        message: 'Your email has been verified!'
      };
      this.showOtpSectionEmail = false;
    }

    this.$notify('Verification successful!');
  } 
},


// method to send the otp
  async sendOtp() {
      try {
        const response = await Api.post('v2/send-common-otp', {
          contact: this.contactInfo,

          type: this.otpType,
        });

        if (response.data.success === true || response.data.status === 'success') {
      this.$notify('OTP sent successfully!');
    } else {
      this.$notify(response.data.message || 'Failed to send OTP. Please try again.', 'error');
      // this.showOtpSection = false;
    }
      } catch (error) {
        this.$notify('Failed to send OTP. Please try again.', 'error');
        // this.showOtpSection = false;
        console.error('OTP send error:', error);
      }
    },
    
    openOtpModal(type) {
      if (type === "phone" && !this.personalInfo.cell_phone) {
        this.$notify("Please enter phone number first.", "warning");
        return;
      }

      if (type === "email" && !this.personalInfo.email) {
        this.$notify("Please enter a phone number first.", "warning");
        return;
      }

      if(type==="phone"){
        this.field="phone";
        this.contactInfo=this.personalInfo.cell_phone;
        this.otpType = type;
     this.sendOtp();

      }
      if(type==="email"){
        this.field="email";
        this.contactInfo=this.personalInfo.email;
        this.otpType = type;
     this.sendOtp();

      }

      this.showOtpModal = true;
    },


     closeOtpModal() {

      this.showOtpModal = false;
    },

    setPersonalData(data) {
      let [repData, name] = [
        this.$store.getters.rep,
        `${data.first_name} ${data.middle_name} ${data.last_name}`,
      ];
      const newRepData = {
        id: repData.id,
        name: name,
        email: data.email,
        phone: Helper.formatPhoneNumber(data.cell_phone),
        image: data.image,
        code: data.agent_code,
      };
      this.$refs.image.value = null;
      this.updateInfoInStorage = false;
      this.$store.commit("setRepData", newRepData);
    },
    getAgentPersonalInfo() {
      Api.get(`${this.version}/get-agent-info`)
        .then((response) => {
          if (response.data.status == "success") {
            this.personalInfo = { ...response.data.data.personal };
            
            this.imgSrc = this.personalInfo.image;
            if (this.imgSrc) this.personalImageSource = "server"
            
            this.businessImage = response.data.data.business.logo;
            if (this.businessImage) this.businessImageSource = "server"

            //storing in cookie
            if (this.updateInfoInStorage) {
              this.setPersonalData(this.personalInfo);
            }
          } else {
            Api.notification(response.data.status, response.data.message);
            console.log(response);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getPersonalAddressList() {
      Api.get(`${this.version}/get-address-list?type=${this.type}`)
        .then((response) => {
          if (response.data.status == "success") {
            this.addressInfo = [...response.data.data];
            //status false to end loop function call from watch
            this.$store.commit("setAddressInfoStatus", false);
          } else {
            console.log(response);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    async updateAsPrimary(id) {
      const proceed = await Helper.confirmDialog(
        "Confirm",
        "Are you sure you want to update primary address?"
      );
      if (proceed) {
        Api.post(`${this.version}/set-primary-address`, {
          type: this.type,
          address_id: id,
        })
          .then((response) => {
            if (response.data.status == "success") {
              this.getPersonalAddressList();
              Api.notification(response.data.status, response.data.message);
            } else {
              Api.notification(response.data.status, response.data.message);
            }
          })
          .catch((e) => {
            console.log(e.response.data.message);
            Api.notification("error", e.response.data.message);
          });
      }
    },
    async deleteAddress(id) {
      const proceed = await Helper.confirmDialog(
        "Confirm",
        "Are you sure you want to delete this address?"
      );

      if (proceed) {
        Api.delete(`${this.version}/delete-agent-address`, {
          type: this.type,
          address_id: id,
        })
          .then((response) => {
            if (response.data.status == "success") {
              this.getPersonalAddressList();
              Api.notification(response.data.status, response.data.message);
            } else {
              Api.notification(response.data.status, response.data.message);
            }
          })
          .catch((e) => {
            console.log(e.response.data.message);
            Api.notification("error", e.response.data.message);
          });
      }
    },
    //update informations
    updateImage() {
      let data = new FormData();
      data.append("type", this.type);
      data.append("image", this.agentImg);
      this.agentImage.image = data;
      this.imageUpdate = true;
      this.imgSrc = URL.createObjectURL(this.agentImg);
    },
    deleteImageRef(type) {
      if (type == "personal") this.agentImg = null;
      if (type == "business") this.businessLogo = null;
    },
    validatePersonalInfo() {
      let result = true;
      let validationArr = [];
      let re = /^[0-9]*$/;

      if (!this.personalInfo.agent_code) {
        validationArr["agent_code"] = "Agent code cannot be empty";
        result = false;
      }

      if (!this.personalInfo.first_name) {
        validationArr["first_name"] = "First Name cannot be empty";
        result = false;
      }

      if (
        this.personalInfo.middle_name &&
        this.personalInfo.middle_name.length > 1
      ) {
        validationArr["middle_name"] =
          "Middle Name cannot be more than 1 character";
        result = false;
      }

      if (!this.personalInfo.last_name) {
        validationArr["last_name"] = "Last Name cannot be empty";
        result = false;
      }

      if (!this.personalInfo.dob) {
        validationArr["dob"] = "DOB cannot be empty";
        result = false;
      }

      if (!this.personalInfo.ssn) {
        validationArr["ssn"] = "SSN cannot be empty";
        result = false;
      } else if (this.personalInfo.ssn && this.personalInfo.ssn.length != 9) {
        validationArr["ssn"] = "SSN should be of 9 digits";
        result = false;
      }

      if (!this.personalInfo.cell_phone) {
        validationArr["cell_phone"] = "Cell Phone cannot be empty";
        result = false;
      } else if (
        this.personalInfo.cell_phone &&
        this.personalInfo.cell_phone.length != 10
      ) {
        validationArr["cell_phone"] = "Cell phone should be of 10 digits";
        result = false;
      } else if (!re.test(this.personalInfo.cell_phone)) {
        validationArr["cell_phone"] = "Cell phone should be in number";
        result = false;
      }

      if (!this.personalInfo.email) {
        validationArr["email"] = "Email Address cannot be empty";
        result = false;
      }

      if (
        this.personalInfo.telephone &&
        this.personalInfo.telephone.length != 10
      ) {
        validationArr["telephone"] =
          "Telephone should be of 10 digits or can be empty";
        result = false;
      } else if (!re.test(this.personalInfo.telephone)) {
        validationArr["telephone"] = "Telephone should be in number";
        result = false;
      }

      this.errors = validationArr;
      return result;
    },
    handleInputChange(event) {
      this.$set(this.errors, event.target.name, "");
    },
    async updatePersonalInfo() {

      this.emailValidationMessage = null;
      this.phoneValidationMessage = null;
      this.emailMsg = false;
      this.phoneMsg = false;
      this.showOtpSectionEmail = false;
      this.showOtpSectionPhone = false;


      this.processing = true;
      this.updateInfoInStorage = true;
      let validation = this.validatePersonalInfo();
      if (this.agentImg) {
        this.updateImage();
      }
      let updatePersonalInfoData = Object.assign({}, this.personalInfo);
      updatePersonalInfoData.image = "";
      const biz_image = await this.updateBusinessImage();
      if (validation) {
        let dob = this.formatDate();
        Api.post(`v3/update-agent-personal`, {
          ...updatePersonalInfoData,
          dob,
          biz_image,
        })
          .then((response) => {
            if (response.data.status == "success") {
              if (!this.imageUpdate) {
                this.processing = false;
                this.getAgentPersonalInfo();
              }
              if (this.agentImg) this.deleteImageRef("personal");
              if (biz_image) this.deleteImageRef("business");
              Api.notification(response.data.status, response.data.message);
            } else if (response.data.statusCode == 401) {
              this.processing = false;
              Api.notification(response.data.status, response.data.message);
            }
          })
          .catch((err) => {
            this.processing = false;
            console.log(err.response.data.message);
            // Api.notification("error", err.response.data.message);

            if(err.response.data.message.includes("Phone is invalid.")){

            
            this.$notify("Phone number is invalid! Please validate via OTP", "error");

            this.phoneMsg=true;
            this.showOtpSectionPhone=true;

            this.phoneValidationMessage = {
            type: 'error',
            title: 'Caution',
            message:'Invalid Phone. Please validate via OTP'
            
          };
          }
          else if(err.response.data.message.includes("Email is invalid - Validated using Neverbounce API")){

            this.$notify("Email is invalid! Please validate via OTP", "error");

            this.emailMsg=true;
            this.showOtpSectionEmail=true;
         

            this.emailValidationMessage={
              type:'error',
              title:'Caution',
              message:'Invalid Email. Please validate via OTP'
            };


          }
          else if(err.response.data.message.includes("Both phone and email are invalid.")){
            this.$notify(err.response.data.message + "Please validate via OTP", "error");

            this.phoneMsg=true;
            this.showOtpSectionPhone=true;

            this.emailMsg=true;
            this.showOtpSectionEmail=true;

            this.phoneValidationMessage = {
              type: 'error',
              title: 'Caution',
              message:'Invalid Phone. Please validate via OTP'
              
            };

            this.emailValidationMessage={
              type:'error',
              title:'Caution',
              message:'Invalid Email. Please validate via OTP'
            };

          }

          else{
            this.$notify(err.response.data.message, "error");

          }
            
          });

        if (this.imageUpdate) {
          Api.post(`${this.version}/update-agent-image`, this.agentImage.image)
            .then((response) => {
              if (response.data.status == "success") {
                this.imageUpdate = false;
                this.processing = false;
                Api.notification(response.data.status, response.data.message);
                this.getAgentPersonalInfo();
              } else if (response.data.statusCode == 401) {
                this.processing = false;
                Api.notification(response.data.status, response.data.message);
              }
            })
            .catch((e) => {
              this.processing = false;
              console.log(e.response.data.message);
              Api.notification("error", e.response.data.message);
            });
        }
      } else {
        this.processing = false;
      }
    },

    async updateBusinessImage() {
      const businessData = new FormData();
      if (this.businessLogo) {
        businessData.append("biz_image", this.businessLogo);
        const biz_image = businessData.get("biz_image");

        const fileBuffer = await new Promise((resolve, reject) => {
          const fileReader = new FileReader();
          fileReader.onloadend = () => {
            resolve(fileReader.result);
          };

          fileReader.onerror = (error) => {
            reject(error);
          };

          fileReader.readAsDataURL(biz_image);
        });

        return fileBuffer;
      }
      return null;
    },

    formatDate() {
      let date = new Date(this.personalInfo.dob);
      let dob =
        date.getFullYear() +
        "-" +
        ("0" + (date.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + date.getDate()).slice(-2);
      return dob;
    },
    async deleteImage(type, callback) {
      await this.$emit("deleteImage", type, callback);
    },
    // setType() {
    //   this.$store.commit("setCurrentAccountInfoType", this.type);
    // },
    initiateOtpValidation(type, identifier) {
      this.otpType = type;
      this.otpIdentifier = identifier;
      this.showOtpModal = true;
    },
    
    handleOtpVerification() {
      // Handle the OTP verification
      this.showOtpModal = false;
    },
  },
};
</script>
<style>
.downline-upload-img {
  /* height: 150px; */
  width: 195px;
  margin-top: 5px;
}
.ai-downline-img-preview{
  max-height: 150px;
}
.upload-close-icon {
  max-width: 24px !important;
  max-height: 24px !important;
  position: absolute;
  cursor: pointer;
  margin-left: -14px;
}
.uploaded {
  width: 100%;
  position: relative;
}
.validate-via-otp-link{
  color: #03c3ec;
}

.rep-otp-validation {
  border: 2px solid #e31717;
  padding: 5px;
  padding-bottom: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 13px;
  font-weight: bold;
  width: 385px;
}

.rep-otp-validation:hover {
  border: 2px solid #a50e0e;
  box-shadow: #eb2a2a;
  background-color: aliceblue;
  cursor: pointer;
}
@media (max-width :375px) {
  .downline-upload-img {
    max-width: 160px;
    margin-top: 5px;
  }
  .personalInfo-wrap .ai-image-wrapper input::before {
    padding: 8px 10px;
  }
}
</style>